import { Stack } from "PFComponents/containers";

import { CustomFieldChangeDecorated, CustomFieldChangelog } from "./custom_field_changelog";

type CustomFieldsChangelogProps = {
  customFields: Record<string, CustomFieldChangeDecorated>;
};

export const CustomFieldsChangelog = ({ customFields }: CustomFieldsChangelogProps) => (
  <Stack>
    {Object.entries(customFields).map(
      ([fieldKey, { before, after, matchable, rankable, customFieldName }]) => (
        <CustomFieldChangelog
          key={fieldKey}
          before={before}
          after={after}
          matchable={matchable}
          rankable={rankable}
          customFieldName={customFieldName}
        />
      )
    )}
  </Stack>
);
